import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Drawer,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  Button,
  Divider,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';

/**
 * MobileMenu - Slide-out drawer for mobile navigation
 */
const MobileMenu = ({ open, onClose, navItems }) => {
  const location = useLocation();

  const isActive = path => location.pathname === path;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: 280 },
      }}
    >
      <Box sx={{ p: 2 }}>
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
          }}
        >
          <Typography variant="h6" fontWeight={700} color="primary.main">
            Boma Trust
          </Typography>
          <IconButton onClick={onClose} aria-label="close menu">
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider />

        {/* Navigation Links */}
        <List>
          {navItems.map(item => (
            <ListItem key={item.path} disablePadding>
              <ListItemButton
                component={Link}
                to={item.path}
                onClick={onClose}
                selected={isActive(item.path)}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontWeight: isActive(item.path) ? 600 : 400,
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Divider sx={{ my: 2 }} />

        {/* Auth Buttons */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Button
            component={Link}
            to="/login"
            variant="outlined"
            color="primary"
            fullWidth
            onClick={onClose}
          >
            Log In
          </Button>
          <Button
            component={Link}
            to="/signup"
            variant="contained"
            color="secondary"
            fullWidth
            onClick={onClose}
          >
            Get Started
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

MobileMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default MobileMenu;
